import { Injectable, Inject, Optional } from '@angular/core';
import { REQUEST, RESPONSE } from '@nguniversal/express-engine/tokens';
import * as express from './express-ssr';

@Injectable()
export class ViewportSize {
    constructor(
        @Inject(REQUEST) @Optional()
        private request : express.ExpressRequest,
        @Inject(RESPONSE) @Optional()
        private response : express.ExpressResponse,
    ) {
    }

    /**
     * Select an appropriate asset size based on the width of the target 
     * display and the given width factor (default 1 = 100%). 
     * Width factor is from 0 to 1 and represents the percent of the 
     * overall screen width that the image will be stretched onto.
     * 
     * @param widthFactor 
     */
    selectAssetSize(widthFactor = 1) {
        // TODO: xxhd class should be "xxhd" not "original" but we need to populate this new class of thumbnails

        let inverseWidthFactor = 1 / widthFactor;

        if (this.width() > inverseWidthFactor*2560) // 4K class
            return 'original';
        else if (this.width() > inverseWidthFactor*1920) // 1440p class
            return 'xhd';
        else if (this.width() > inverseWidthFactor*1280) // 1080p class
            return 'hd';
        else if (this.width() > inverseWidthFactor*1137) // 720p class
            return 'hd720';
        else if (this.width() > inverseWidthFactor*551) //  640p class
            return 'sd';
        else if (this.width() > inverseWidthFactor*250) //  310p class
            return 'sm';
        else //  140p class
            return 'xs';
    }

    width() {
        if (typeof screen !== 'undefined')
            return screen.width;

        if (this.request && this.request.header('Width'))
            return parseInt(this.request.header('Width'));

        return undefined;
    }
}